import { admins_api_complaints_delete_url } from 'mk/urls/functions';

export function deleteComplaints(xhr, entity: string, id: number) {
    return xhr.post(admins_api_complaints_delete_url(entity, id));
}
